import PropTypes from "prop-types";
import React from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";



//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

const Header = (props) => {
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="navbar-brand-box text-center">
            <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
                  <img
                    src="/iXiVERSE-NEON-100.png"
                    alt="logo-sm-dark"
                    height="50"
                    width="50"
                  />
                </span>
                <span className="logo-lg">
                  <img src="/iXiVERSE-NEON-100.png" 
                  alt="logo-dark" 
                  height="100"
                  width="100"
                />
                </span>
            </Link>

            <Link to="/" className="logo logo-light">
            <span className="logo-sm">
                  <img
                    src="/iXiVERSE-NEON-100.png"
                    alt="logo-sm-light"
                    height="50"
                    width="50"
                  />
                </span>
                <span className="logo-lg">
                  <img
                    src="/iXiVERSE-NEON-100.png"
                    alt="logo-light"
                    height="100"
                    width="100"
                  />
                </span>
            </Link>
          </div>
          <div className="d-flex">
            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>



            <ProfileMenu />

            <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle waves-effect"
              >
                <i className="mdi mdi-cog"></i>
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
